import React from 'react';
import { AvatarTypeTokens, } from '@voltmoney/schema';
import _map from 'lodash-es/map';
import AvatarBase from './Avatar.Base';
import { View } from 'react-native';
const Avatar = ({ uri, initialLetter, uris, type = AvatarTypeTokens.SINGLE, ...props }) => {
    if (!uri && type === AvatarTypeTokens.SINGLE)
        return React.createElement(React.Fragment, null);
    if (!uris && type === AvatarTypeTokens.MULTIPLE)
        return React.createElement(React.Fragment, null);
    return (React.createElement(View, { style: {
            alignItems: 'center',
            justifyContent: 'center',
        } }, type === AvatarTypeTokens.SINGLE && uri ? (React.createElement(AvatarBase, { uri: uri, ...props, initialLetter: initialLetter })) : (uris &&
        type === AvatarTypeTokens.MULTIPLE &&
        _map(uris.slice(0, 3), (item, index) => [
            React.createElement(AvatarBase, { key: index, uri: item, overlap: index ? true : false, ...props }),
        ]))));
};
export default React.memo(Avatar);
export { Avatar };
